<template>
  <div v-if="$companyConfiguration.knowledgeBase.isEnabled()">

    <page-heading heading="Как это работает?">
      <div slot="right">
        <el-button
          v-if="canManage"
          type="primary"
          size="small"
          icon="fas fa-plus"
          @click="openEditDialog()"
        >
          Добавить ссылку
        </el-button>
      </div>
    </page-heading>

    <el-card>
      <div v-loading="loading" class="knowledge-base-links">
        <Container
          lock-axis="y"
          drag-handle-selector=".knowledge-base-link-drag-handle"
          @drop="onDrop($event)"
        >
          <Draggable
            v-for="link in links"
            :key="link.id"
          >
            <div class="knowledge-base-link">
              <el-button
                v-if="canManage"
                class="knowledge-base-link-drag-handle table-action-button"
                size="mini"
                type="text"
                icon="fas fa-grip-vertical"
                title="Перетащите, чтобы изменить порядок"
              >
              </el-button>
              <a
                :href="link.url"
                target="_blank"
                rel="noopener noreferrer"
                class="knowledge-base-link-name"
              >
                {{ link.name }}
              </a>
              <div v-if="canManage" class="knowledge-base-link-actions">
                <el-button
                  class="table-action-button"
                  size="mini"
                  round
                  icon="fas fa-pen"
                  @click="openEditDialog(link)"
                >
                </el-button>
                <el-button
                  class="table-action-button"
                  size="mini"
                  round
                  icon="far fa-trash-alt"
                  @click="confirmDeleteLink(link)"
                >
                </el-button>
              </div>
            </div>
          </Draggable>
        </Container>
        <div v-if="!loading && !links.length" class="knowledge-base-links-empty">Нет данных</div>
      </div>
    </el-card>

    <knowledge-base-link-edit-dialog
      ref="editDialog"
      @link-saved="loadLinks"
    ></knowledge-base-link-edit-dialog>

  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import KnowledgeBaseLinkEditDialog from "@/components/knowledgeBase/KnowledgeBaseLinkEditDialog.vue";
import {Container, Draggable} from 'vue-dndrop';
import {applyDragForDndrop} from "@/utils/helpers";
import {mapGetters} from "vuex";

export default {
  name: 'KnowledgeBase',
  components: {KnowledgeBaseLinkEditDialog, PageHeading, Container, Draggable},

  computed: {
    ...mapGetters(['user']),
    canManage() {
      return this.$canAndRulesPass(this.user, this.$permissions.KNOWLEDGE_BASE.MANAGE);
    },
  },

  data() {
    return {
      loading: false,
      links: [],
    }
  },

  mounted() {
    this.loadLinks();
  },

  methods: {
    loadLinks() {
      this.loading = true;
      this.$api.knowledgeBase.search({'per-page': 500})
        .then(({data}) => {
          this.links = data.links;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    onDrop(dragResult) {
      const {removedIndex, addedIndex} = dragResult;
      if (removedIndex === null || addedIndex === null || removedIndex === addedIndex) {
        return;
      }

      const movedLink = this.links[removedIndex];
      this.links = applyDragForDndrop(this.links, dragResult);

      this.loading = true;
      this.$api.knowledgeBase.setOrder({
        id: movedLink.id,
        order: addedIndex + 1,
      })
        .then(() => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Порядок ссылок успешно сохранен'
          });
        })
        .finally(() => {
          this.loadLinks();
        })
    },

    openEditDialog(link = {}) {
      this.$refs.editDialog.open(link);
    },

    confirmDeleteLink(link) {
      this.$confirm('Ссылка будет удалена без возможности восстановления', 'Удаление ссылки', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'warning',
      })
        .then(() => this.deleteLink(link))
    },

    deleteLink(link) {
      this.$api.knowledgeBase.delete({id: link.id})
        .then(() => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Ссылка успешно удалена'
          });
        })
        .finally(() => {
          this.loadLinks();
        })
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

.knowledge-base-links {
  min-height: 40px;

  &-empty {
    color: #909399;
    text-align: center;
    padding: 20px 0;
  }

  ::v-deep .dndrop-draggable-wrapper:last-child .knowledge-base-link {
    border-bottom: none;
  }
}

.knowledge-base-link {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #EBEEF5;

  &-drag-handle {
    cursor: move;
    color: #909399;
    margin-right: 10px;
  }

  &-name {
    flex: 1;
    color: $--color-primary;
    text-decoration: underline dotted $--color-primary;
  }

  &-actions {
    white-space: nowrap;
    margin-left: 10px;
  }
}
</style>
